import { DateTime } from 'luxon';

import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { formatAddress } from 'dashboard/lib/utils/formatters';
import { formatCompanyName } from 'dashboard/lib/utils/stringFormat';
import { ReportBusinessLookup } from 'dashboard/models/report/business-lookup';
import Card from 'design-system/components/Card';

interface BusinessSummaryCardProps {
  report: ReportBusinessLookup;
}

const BusinessLookupSummary = ({ report }: BusinessSummaryCardProps) => {
  const {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    query: { 'business-name': businessName },
    result,
  } = report.attributes;

  const {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    aliases,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    addresses,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    headcount: headCount,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    'phone-numbers': phoneNumbers,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    websites,
  } = result;

  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const ein = result.identifiers?.filter((id) => id.type === 'ein')?.map((id) => id['file-number']);
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const corporateStructure = result['legal-entity-type'];
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const yearIncorporated = result['date-of-incorporation']?.year;
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const monthIncorporated = result['date-of-incorporation']?.month;
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const dayIncorporated = result['date-of-incorporation']?.day;

  const body = (
    <>
      <AttributeGrid colCount={3}>
        <AttributeItem
          title='Aliases'
          placeholder='-'
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          value={aliases.map((alias) => formatCompanyName(alias))}
          toggleable={false}
          dataTest='report-business-lookup__match-aliases'
        />
        <AttributeItem
          title='Addresses'
          placeholder='-'
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          value={addresses.map((address) =>
            formatAddress({
              addressStreet1: address['street-1'],
              addressStreet2: address['street-2'],
              addressCity: address.city,
              addressSubdivision: address.subdivision,
              addressPostalCode: address['postal-code'],
            }),
          )}
          toggleable={false}
          dataTest='report-business-lookup__match-addresses'
        />
        <AttributeItem
          title='Websites'
          placeholder='-'
          value={websites.map((website: string) => (
            <a key={website} href={website}>
              {website}
            </a>
          ))}
          toggleable={false}
          dataTest='report-business-lookup__match-websites'
        />
        <AttributeItem
          title='Company structure'
          placeholder='-'
          value={formatCompanyName(corporateStructure)}
          toggleable={false}
          dataTest='report-business-lookup__match-corporate-structure'
        />
        <AttributeItem
          title='Business EIN'
          placeholder='-'
          value={ein}
          toggleable={false}
          dataTest='report-business-lookup__match-ein'
        />
        {headCount != null && (
          <AttributeItem
            title='Head count'
            placeholder='-'
            value={headCount}
            toggleable={false}
            dataTest='report-business-lookup__match-head-count'
          />
        )}
        {monthIncorporated == null && dayIncorporated == null ? (
          <AttributeItem
            title='Year incorporated'
            placeholder='-'
            value={yearIncorporated}
            toggleable={false}
            dataTest='report-business-lookup__match-year-incorporated'
          />
        ) : (
          <AttributeItem
            title='Date incorporated'
            placeholder='-'
            value={
              yearIncorporated && monthIncorporated && dayIncorporated
                ? DateTime.local(
                    parseInt(yearIncorporated),
                    parseInt(monthIncorporated),
                    parseInt(dayIncorporated),
                  ).toFormat('y-L-dd')
                : ''
            }
            toggleable={false}
            dataTest='report-business-lookup__match-date-incorporated'
          />
        )}
        <AttributeItem
          title='Phone numbers'
          placeholder='-'
          value={phoneNumbers}
          toggleable={false}
          dataTest='report-business-lookup__match-phone-numbers'
        />
      </AttributeGrid>
    </>
  );

  return (
    <>
      <Card.Title>{businessName}</Card.Title>
      {body}
    </>
  );
};

export default BusinessLookupSummary;
